import React from 'react';
import styles from '../form-field.scss';
import commonStyles from '../common.scss';

import { TransitionGroup, CustomTransition } from 'ui/transition';
import Linkify from 'linkifyjs/react';

const NOTE_TRANSITION = {
  in: { opacity: 0, transform: 'translateY(-10px)' },
  end: { opacity: 1, transform: 'translateY(0)' }
};

type Props = {
  note?: string,
  error?: string,
  style?: React.CSSProperties
};

const linkProps = {
  tabIndex: -1
};
export default function FieldNote({ note, error, style }: Props) {
  return (
    <TransitionGroup className={styles.fieldNote} style={style}>
      {!error && note && (
        <CustomTransition
          start={NOTE_TRANSITION.in}
          end={NOTE_TRANSITION.end}
          className={styles.help}>
          
          <Linkify options={{attributes: linkProps}}>{note}</Linkify>
        </CustomTransition>
      )}
      {error && (
        <CustomTransition
          start={NOTE_TRANSITION.in}
          end={NOTE_TRANSITION.end}
          className="text-error">
          
          {error}
        </CustomTransition>
      )}
    </TransitionGroup>
  );
}
